export function Projects() {
    return (
        <span>
            Projects
        </span>
    )
}